import React from "react";
import PropTypes from "prop-types";
import css from "./Footer.scss";

const Footer = (props) => {
    return <div className={css.footer}><a href = {props.url}> {props.text} </a></div>
};

Footer.propTypes = {
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
}

export default Footer;
